/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ResolveShadowMCPInventoryRequestForm,
  ResolveShadowMCPInventoryRequestForm$Outbound,
  ResolveShadowMCPInventoryRequestForm$outboundSchema,
} from "../components/resolveshadowmcpinventoryrequestform.js";

export type ResolveShadowMCPInventoryRequestSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ResolveShadowMCPInventoryRequestRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  resolveShadowMCPInventoryRequestForm: ResolveShadowMCPInventoryRequestForm;
};

/** @internal */
export type ResolveShadowMCPInventoryRequestSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResolveShadowMCPInventoryRequestSecurity$outboundSchema:
  z.ZodMiniType<
    ResolveShadowMCPInventoryRequestSecurity$Outbound,
    ResolveShadowMCPInventoryRequestSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function resolveShadowMCPInventoryRequestSecurityToJSON(
  resolveShadowMCPInventoryRequestSecurity:
    ResolveShadowMCPInventoryRequestSecurity,
): string {
  return JSON.stringify(
    ResolveShadowMCPInventoryRequestSecurity$outboundSchema.parse(
      resolveShadowMCPInventoryRequestSecurity,
    ),
  );
}

/** @internal */
export type ResolveShadowMCPInventoryRequestRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ResolveShadowMCPInventoryRequestForm:
    ResolveShadowMCPInventoryRequestForm$Outbound;
};

/** @internal */
export const ResolveShadowMCPInventoryRequestRequest$outboundSchema:
  z.ZodMiniType<
    ResolveShadowMCPInventoryRequestRequest$Outbound,
    ResolveShadowMCPInventoryRequestRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      resolveShadowMCPInventoryRequestForm:
        ResolveShadowMCPInventoryRequestForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        resolveShadowMCPInventoryRequestForm:
          "ResolveShadowMCPInventoryRequestForm",
      });
    }),
  );

export function resolveShadowMCPInventoryRequestRequestToJSON(
  resolveShadowMCPInventoryRequestRequest:
    ResolveShadowMCPInventoryRequestRequest,
): string {
  return JSON.stringify(
    ResolveShadowMCPInventoryRequestRequest$outboundSchema.parse(
      resolveShadowMCPInventoryRequestRequest,
    ),
  );
}
